import { Component, OnInit } from "@angular/core";
import {
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from "@angular/forms";
import { AppLayoutComponent } from "../../../shared/components/app-layout/app-layout.component";
import { SnackBarService } from "../../services/snack-bar.service";

@Component({
    selector: "app-talk-to-us",
    imports: [AppLayoutComponent, ReactiveFormsModule],
    templateUrl: "./talk-to-us.component.html",
    styleUrl: "./talk-to-us.component.scss"
})
export class TalkToUsComponent implements OnInit {
  contactUsForm!: FormGroup;

  constructor(
    private fb: FormBuilder,
    private readonly snackbarService: SnackBarService,
  ) {}

  ngOnInit(): void {
    this.contactUsForm = this.fb.group({
      name: ["", Validators.required],
      email: ["", Validators.required],
      phone: ["", Validators.required],
      subject: ["", Validators.required],
      message: ["", Validators.required],
    });
  }

  onSubmit() {
    // if (this.contactUsForm.valid) {
    //   const formData = this.contactUsForm.value;
    //   this.contactUsService.contactUs(formData).subscribe({
    //     next: (response) => {
    //       this.snackbarService.openSnackBar(
    //         "Formulário enviado com sucesso!",
    //         "Fechar",
    //         "success"
    //       );
    //       this.contactUsForm.reset();
    //     },
    //     error: (error) => {
    //       this.snackbarService.openSnackBar(
    //         "Erro ao enviar o formulário.",
    //         "Fechar",
    //         "error"
    //       );
    //       console.error(error);
    //     }
    //   });
    // } else {
    //   this.snackbarService.openSnackBar(
    //     "Formulario não tem dados válidos",
    //     "Fechar",
    //     "error"
    //   );
    // }
  }
}
